<template>
  <div id="accordion" :key="numberOfDisplayedLocations + '_' + locations.length">
    <template v-for="(location, locationIndex) in locationsWithfilteredDocuments">
      <template v-if="location.documents.length > 0 && locationIndex <= numberOfDisplayedLocations">
        <template v-for="(document, documentIndex) in location.documents">
          <location-card :key="location.id + '_' + documentIndex"
            :location="location"
            :document="document"
            :location-index="locationIndex"
            :document-index="documentIndex">
          </location-card>
        </template>
      </template>
    </template>
    <infinite-loading spinner="spiral" @infinite="infiniteHandler">
      <div slot="no-results"></div>
    </infinite-loading>
       
  </div><!-- end accordion -->
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';

export default {
  components: {
    InfiniteLoading
  },
  data() {
    return {
      numberOfDisplayedLocations: 5
    }
  },

  props: {
    locations: { type: Array, required: true },
    showPrivateType: { type: Boolean, required: false, default: true },
    showRoyalType: { type: Boolean, required: false, default: true },
    showPlaceOfWriting: { type: Boolean, required: false, default: true },
    showPlaceOfGoods: { type: Boolean, required: false, default: true },
    showMentionedPlace: { type: Boolean, required: false, default: true },
    showOnlyExhibited: { type: Boolean, required: false, default: false },
  },

  computed: {
    locationsWithfilteredDocuments: function() {

      let _this = this;
      let locationsWithfilteredDocuments = [];
      let locationsToFilter = this.locations;
      
      locationsToFilter.forEach(function(location){
        let locationToFilter = {};
        // create a local copy or the documents object to avoid overwriting the original
        locationToFilter = Object.assign(locationToFilter, location);
        locationToFilter.documents.forEach(function(document){
          document.location_types = JSON.parse(document.pivot.location_types);
        });
        let documentsToFilter = locationToFilter.documents;
        let filteredDocuments = documentsToFilter.filter(function(documentToFilter) {
          return (_this.showPlaceOfWriting && documentToFilter.location_types.indexOf('place_of_writing') !== -1)
                    || (_this.showPlaceOfGoods && documentToFilter.location_types.indexOf('place_of_goods') !== -1)
                    || (_this.showMentionedPlace && documentToFilter.location_types.indexOf('mentioned_place') !== -1);
        });
        filteredDocuments = filteredDocuments.filter(function(documentToFilter) {
          return (_this.showPrivateType && documentToFilter.type.indexOf('privaturkunde') !== -1)
                    || (_this.showRoyalType && documentToFilter.type.indexOf('herrscherurkunde') !== -1);
        });
        if(_this.showOnlyExhibited) {
          filteredDocuments = filteredDocuments.filter(documentToFilter => documentToFilter.currently_on_display);
        }

        locationToFilter.documents = filteredDocuments;
        locationsWithfilteredDocuments.push(locationToFilter); 
      });
      return locationsWithfilteredDocuments;
    }
  },

  methods: {
    infiniteHandler(state) {
      if(this.numberOfDisplayedLocations < this.locations.length) {
        this.numberOfDisplayedLocations += 50;
      } else {
        state.complete();
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>


